import { createFileRoute } from '@tanstack/react-router'

import { toStringList } from '@/lib/searchParams'
import { ParallelWorkflows } from '@/pages/ControlRoom/ParallelWorkflows'

/**
 * A step can only appear once in a group, so a repeated id is a malformed link
 * rather than a second panel.
 */
export const validateParallelSearch = (
  search: Record<string, unknown>,
): { stepIds: string[] } => ({
  stepIds: [...new Set(toStringList(search.stepIds))],
})

export const Route = createFileRoute('/_app/control-room/workflow/parallel/')({
  component: ParallelWorkflows,
  validateSearch: validateParallelSearch,
})
